import { Component, inject, OnInit, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { DefaultConstant } from '../../../../../constants/enum/common/default.enum';
import { GoogleMapsLoaderService } from '../../../../../core/services/google-maps-loader.service';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { TIMESHEET_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/timesheet';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { TimesheetStoreService } from '../../../../../state/modules/timesheet/timesheet-store.service';

@Component({
  standalone: false,
  selector: 'kt-end-loop',
  templateUrl: './end-loop.component.html',
  styleUrls: ['./end-loop.component.scss'],
})
export class EndLoopComponent implements OnInit {
  location: any = {};
  shiftDetails: any = null;
  distanceFromActualLocation = 0;
  buttonConfig = BUTTON_CONFIG;
  defaultEnum = DefaultConstant;
  loading = signal(false);
  user_id = 0;
  mapReady = signal(false);
  private readonly mapsLoader = inject(GoogleMapsLoaderService);

  constructor(private timesheetStoreService: TimesheetStoreService, public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.mapsLoader.load().then(() => this.mapReady.set(true));
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.location.latitude = position.coords.latitude;
        this.location.longitude = position.coords.longitude;
        this.distanceFromActualLocation = CommonUtil.distance(this.location.latitude, this.location.longitude, (+this.shiftDetails.area.area_latitude), (+this.shiftDetails.area.area_longitude), 'K');
      });
    }
  }


  endLoopHandler() {
    if (this.loading()) {
      return;
    }
    const payload = {
      client_id: this.shiftDetails.client.client_id,
      location_id: this.shiftDetails.location.location_id,
      area_id: this.shiftDetails.area.area_id,
      timezone_id: 0,
      user_id: this.user_id,
      is_unscheduled: this.shiftDetails.shift ? false : true,
      timesheet_id: this.shiftDetails.timesheet.timesheet_id,
      loop_id: this.shiftDetails.timesheet.active_loop.loop.loop_id,
      shift_loop_id: this.shiftDetails.timesheet.active_loop.loop.shift_loop_id,
      timesheet_transaction: {
        timesheet_transaction_config: {},
        timesheet_transaction_device_config: CommonUtil.getShiftMetaData(),
        timesheet_transaction_device: 'Web',
        timesheet_transaction_app_version: '',
        timesheet_transaction_scan_type: '',
        timesheet_transaction_scan_image_url: '',
        timesheet_transaction_notes: '',
        timesheet_transaction_latitude: this.location && this.location.latitude ? this.location.latitude.toString() : '',
        timesheet_transaction_longitude: this.location && this.location.longitude ? this.location.longitude.toString() : '',
        timesheet_transaction_accuracy: 0,
      },
    };
    this.dispatchEndLoop(payload);
  }

  endLoop(data) {
    this.loading.set(false);
    if (data.success) {
      this.activeModal.close({ reload: true });
    }
  }

  dispatchEndLoop(data) {
    this.loading.set(true);
    this.timesheetStoreService.dispatchTimesheetCommon({
      module: TIMESHEET_METHOD_CONSTANT.END_LOOP,
      method: API_METHOD_CONSTANTS.INSERT,
      data,
      callback: this.endLoop.bind(this),
    });
  }

}
